<template>
    <AppLayoutBase>
        <template slot="drawer">

        </template>

        <template slot="main">

        </template>
    </AppLayoutBase>
</template>

<script>
    export default {
        name: "AdminOrgaUnits"
    }
</script>

<style scoped>

</style>